<template>
  <b-modal id="taskCloseManuallyModal" size="xl" hide-footer @hidden="resetData">
    <b-row slot="modal-header">
      <b-col>
        <h6>{{ $t('modals.excmtask.taskCloseManuallyModalHeader') }}</h6>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <p class="form-control-label">{{$t('modals.excmtask.date')}}: {{ date }}</p>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="form-group">
          <label class="form-control-label">{{$t('modals.excmtask.hourFrom')}}:</label>
          <fg-input>
<!--            <el-date-picker-->
<!--                    v-model="taskDates.startDate"-->
<!--                    type="datetime"-->
<!--                    :placeholder="$t('modals.excmtask.startDate')"-->
<!--                    default-time="12:00:00">-->
<!--            </el-date-picker>-->
            <el-time-picker v-model="hourFrom"></el-time-picker>
          </fg-input>
        </div>
      </b-col>
      <b-col>
        <div class="form-group">
          <label class="form-control-label">{{ $t('modals.excmtask.timeOrDate') }}:</label>
          <b-form-group>
            <b-form-radio-group
                    v-model="timeOrDate"
                    :options="timeOrDateOptions"
                    buttons
                    button-variant="outline-primary"
                    name="radios-btn-default"
            ></b-form-radio-group>
          </b-form-group>
        </div>
      </b-col>
      <b-col v-if="timeOrDate === 1">
        <div class="form-group">
          <label class="form-control-label">{{$t('modals.excmtask.hourTo')}}:</label>
          <fg-input>
<!--            <el-date-picker-->
<!--                    v-model="taskDates.finishDate"-->
<!--                    type="datetime"-->
<!--                    :placeholder="$t('modals.excmtask.finishDate')"-->
<!--                    default-time="12:00:00">-->
<!--            </el-date-picker>-->
            <el-time-picker v-model="hourTo"></el-time-picker>
          </fg-input>
        </div>
      </b-col>
      <b-col v-else>
        <div class="form-group">
          <label class="form-control-label">{{$t('modals.excmtask.minutes')}}:</label>
          <input
                  v-model="minutes"
                  class="form-control"
                  type="text"
                  :placeholder="$t('modals.excmtask.minutes')">
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-btn variant="success" @click="closeTask()">{{ $t('buttons.submit') }}</b-btn>
        <b-btn variant="danger" @click="closeModal()">{{ $t('buttons.close') }}</b-btn>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
// import EXCMAgreementConsentUpdate from '../Update.vue'
import getId from '@/utils/getIdFromLink'
export default {
  name: 'TaskCloseManuallyModal',
  components: {
    // EXCMAgreementConsentUpdate
  },
  computed: {
    show () {
      return this.$store.state.modals.excmtask.closeManually.show
    },
    taskObject () {
      return this.$store.state.modals.excmtask.closeManually.taskObject
    },
    close () {
      return this.$store.state.modals.excmtask.closeManually.close
    },
    dailyPlanItemDate () {
      return this.$store.state.modals.excmtask.closeManually.dailyPlanItemDate
    }
  },
  watch: {
    'show': function (val) {
      this.openModal()
    },
    'taskObject': function (val) {
      this.openModal()
    },
    'dailyPlanItemDate': function (val) {
      this.openModal()
    },
    'close': function (val) {
      this.closeModal()
    },
    'timeOrDate': function (val) {
      this.hourTo = ''
      this.taskDates.finishDate = null
      this.minutes = ''
    }
  },
  data () {
    return {
      task: null,
      date: '',
      hourFrom: '',
      hourTo: '',
      taskDates: {
        startDate: null,
        finishDate: null
      },
      minutes: '',
      timeOrDate: 0,
      timeOrDateOptions: [
        {
          value: 0,
          text: this.$t('modals.excmtask.timeOrDateOptions.time')
        },
        {
          value: 1,
          text: this.$t('modals.excmtask.timeOrDateOptions.date')
        }
      ]
    }
  },
  created () {
    this.unwatchMinutes = this.$watch(
      function () {
        return this.minutes
      },
      function (newValue) {
        this.calculateFinishDate()
      }
    )
    this.unwatchHourFrom = this.$watch(
      function () {
        return this.hourFrom
      },
      function (newValue) {
        let date = this.date + ' ' + this.$moment(this.hourFrom).format('HH:mm:ss')
        this.taskDates.startDate = this.$moment(date).format('YYYY-MM-DD HH:mm:ss')
        this.calculateFinishDate()
      }
    )
    this.unwatchHourTo = this.$watch(
      function () {
        return this.hourTo
      },
      function (newValue) {
        if (newValue) {
          let date = this.date + ' ' + this.$moment(this.hourTo).format('HH:mm:ss')
          this.taskDates.finishDate = this.$moment(date).format('YYYY-MM-DD HH:mm:ss')
          // this.calculateFinishDate()
        }
      }
    )
  },
  methods: {
    calculateFinishDate () {
      if (this.timeOrDate === 0 && this.taskDates.startDate && this.minutes) {
        this.taskDates.finishDate = this.$moment(this.taskDates.startDate).add(parseInt(this.minutes), 'minutes').format('YYYY-MM-DD HH:mm:ss')
      }
    },
    openModal () {
      if (this.show === 1 && this.taskObject && this.dailyPlanItemDate) {
        this.task = Object.assign({}, this.taskObject)
        this.date = this.dailyPlanItemDate
        if (this.task.started === 1 && this.task.startDate) {
          this.taskDates.startDate = this.$moment(this.task.startDate).format('YYYY-MM-DD HH:mm:ss')
        }
        this.$store.state.modals.excmtask.closeManually.show = 0
        this.$store.state.modals.excmtask.closeManually.taskObject = null
        this.$store.state.modals.excmtask.closeManually.dailyPlanItemDate = null
        this.$bvModal.show('taskCloseManuallyModal')
      }
    },
    closeModal () {
      if (this.close === 1) {
        this.$store.state.modals.excmtask.closeManually.close = 0
      }
      this.$bvModal.hide('taskCloseManuallyModal')
    },
    getIdLink (link) {
      return getId(link)
    },
    closeTask () {
      let startDate = this.taskDates.startDate
      let finishDate = this.taskDates.finishDate
      if (startDate >= finishDate) {
        let text = this.$t('error.timeStartLaterThanTimeStop')
        this.$Swal({
          type: 'warning',
          title: text,
          timer: 2500
        })
      // } else if (this.$route.name === 'DailyPlanShow' && ) {
      //   let text = this.$t('error.taskMustBeClosedWhenDailyItem')
      //   this.$Swal({
      //     type: 'warning',
      //     title: text,
      //     timer: 2500
      //   })
      } else {
        this.$Swal({
          title: this.$t('notifications.excmtask.titleCloseTask'),
          text: this.$t('notifications.excmtask.textCloseTask'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$t('buttons.yes'),
          cancelButtonText: this.$t('buttons.no')
        }).then(response => {
          this.$http.put('api/e_x_c_m_tasks/' + this.getIdLink(this.task['@id']) + '/finish',
            {
              startDate: startDate,
              finishDate: finishDate
            }
          )
            .then(response => {
              this.clearData()
              this.closeModal()
              this.$Swal({
                type: 'success',
                title: this.$t('notifications.excmtask.taskClosed'),
                timer: 2500
              })
              this.$store.state.modals.excmtask.closeManually.closed = 1
            })
            .catch(error => {
              // if (error.response.status === 400) {
              let text = ''
              for (let i in error.response.data) {
                text += error.response.data[i] + '\n'
              }
              this.$Swal({
                type: 'warning',
                title: text,
                timer: 2500
              })
              // }
              console.log(error)
            })
        }, dismiss => {
          // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
          if (dismiss === 'cancel') {
            this.$Swal({
              title: this.$t('notifications.canceled'),
              text: this.$t('notifications.excmtask.taskNotClosed'),
              type: 'error'
            })
          }
        })
      }
    },
    resetData () {
      this.clearData()
    },
    clearData () {
      this.taskDates.startDate = null
      this.taskDates.finishDate = null
      this.timeOrDate = 0
      this.minutes = ''
    }
  }
}
</script>
